/**
 * Vitrine em dolar (spec 020, decisoes 1 a 3; spec 008, decisao 3). O produto da Global e anunciado em dolar e cobrado
 * em real: o cliente escolhe pelo dolar e paga em real, e e essa diferenca que vira reclamacao quando o dolar mexe.
 *
 * Mora no contrato, e nao no servico, porque duas pessoas precisam da MESMA conta: o `pagamentos`, que cobra, e o
 * painel, que mostra ao administrador quanto o cliente vai pagar antes de criar o checkout. Duas implementacoes dariam
 * precos diferentes na tela e no banco. Quem manda continua sendo o servico: ele recalcula e recusa divergencia.
 *
 * Duas regras que nao podem escorregar:
 *  - **quem manda no dinheiro e o real.** O valor em real e calculado uma vez, congelado no checkout e e ele que vai
 *    pro gateway. O dolar nunca e reconvertido na hora da compra: duas pessoas que compram o mesmo checkout pagam o
 *    mesmo valor, mesmo que o dolar tenha mexido entre uma e outra;
 *  - **a cotacao tem quatro casas.** Arredondar antes da conta muda o preco: 39 x 5,1527 da R$ 200,96, e 39 x 5,15
 *    daria R$ 200,85. Onze centavos por venda que ninguem sabe explicar depois.
 */
const QUATRO_CASAS = /^\d{1,4}(\.\d{1,4})?$/;
export function cotacaoValida(c) {
    return QUATRO_CASAS.test(c.trim()) && Number(c) > 0;
}
/**
 * Quanto custa, em centavos de real, um preco de `usdCentavos` centavos de dolar a esta cotacao.
 * A conta e feita em inteiros (centavos x dez-milesimos) pra nao depender de ponto flutuante, e arredonda no fim.
 */
export function realDoDolar(usdCentavos, cotacao) {
    if (!Number.isInteger(usdCentavos) || usdCentavos <= 0)
        throw new Error("preco em dolar invalido");
    if (!cotacaoValida(cotacao))
        throw new Error("cotacao invalida: use ate quatro casas, como 5.1527");
    const [inteira = "0", decimal = ""] = cotacao.trim().split(".");
    const dezMilesimos = BigInt(inteira) * 10000n + BigInt(decimal.padEnd(4, "0"));
    const bruto = BigInt(usdCentavos) * dezMilesimos; // centavos de dolar x dez-milesimos de real
    // Arredonda PRA CIMA, como o sistema antigo (`usdParaBrl`, com o motivo escrito la): "a diferenca e de no maximo um
    // centavo, e ela fica com quem vende, nao com quem paga a taxa do adquirente depois". Os seis precos da Global batem
    // centavo a centavo so com isto; arredondar pro mais proximo dava um a menos em quatro deles.
    return Number((bruto + 9999n) / 10000n);
}
/**
 * O contrario, so pra mostrar (Vitor, 15/10: no checkout da Global o valor em destaque e o dolar): quanto vale em
 * dolar um valor em real a esta cotacao, pra beneficio, cupom, juros e total, que nascem em real. Arredonda PRA BAIXO,
 * pra o preco anunciado voltar exato: `dolarDoReal(realDoDolar(usd, c), c) === usd`. O que se cobra continua sendo o real.
 */
export function dolarDoReal(brlCentavos, cotacao) {
    if (!Number.isInteger(brlCentavos) || brlCentavos < 0)
        throw new Error("valor em real invalido");
    if (!cotacaoValida(cotacao))
        throw new Error("cotacao invalida: use ate quatro casas, como 5.1527");
    const [inteira = "0", decimal = ""] = cotacao.trim().split(".");
    const dezMilesimos = BigInt(inteira) * 10000n + BigInt(decimal.padEnd(4, "0"));
    return Number((BigInt(brlCentavos) * 10000n) / dezMilesimos);
}
/** Como a cotacao aparece pra quem le: "5,1527". */
export const cotacaoPorExtenso = (c) => Number(c).toLocaleString("pt-BR", { minimumFractionDigits: 4, maximumFractionDigits: 4 });
//# sourceMappingURL=dolar.js.map